import Badge from 'components/Badge';
import { InvoiceStatus } from '../../types';
import { statusLabel } from '../../helpers';
import { CellWrapper } from '../../styled';

const variantMap: Record<InvoiceStatus, 'warning' | 'brand' | 'error' | 'success' | 'default'> = {
    draft: 'warning',
    sent: 'brand',
    overdue: 'error',
    paid: 'success',
    void: 'error',
};

interface InvoiceStatusBadgeProps {
    value?: InvoiceStatus;
}

export const InvoiceStatusBadge = ({ value }: InvoiceStatusBadgeProps) => {
    if (!value) return null;
    return (
        <Badge
            variant={variantMap[value]}
            borderRadius="semi-square"
            label={statusLabel(value)}
        />
    );
};

interface StatusColumnProps {
    value?: InvoiceStatus;
}

const StatusColumn = ({ value }: StatusColumnProps) => (
    <CellWrapper>
        <InvoiceStatusBadge value={value} />
    </CellWrapper>
);

export default StatusColumn;
